import { render } from "./classes.vue?vue&type=template&id=ea3f46e0&ts=true"
import script from "./classes.vue?vue&type=script&lang=ts"
export * from "./classes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__